import { ActiveForms } from '@core/interfaces/form.interface';
import { IMedia }      from '@core/interfaces/media-interfaces';
import { IPageLoader } from '@core/store/feature/ui/state';
import { Action }      from '@ngrx/store';

export enum ActionTypes {
	SET_ACTIVE_FORMS = '[UI] Active Forms',
	SET_COMPACT_NAV_MENU = '[UI] Toggle Compact Nav Menu',
	SET_MEDIA = '[UI] Set MEDIA',
	SET_UI_EVENT = '[UI] Set UI Event',
	SET_UI_LANGUAGE = '[UI] Set Language',
	SHOW_PAGE_LOADER_AND_COUNT_UP = '[UI] Show Page Loader And Count Up',
	HIDE_PAGE_LOADER_AND_RESET_COUNTER = '[UI] Hide Page Loader And Reset Counter',
	HIDE_PAGE_LOADER_OR_COUNT_DOWN = '[UI] Hide Page Loader Or Count Down'
}


export class SetActiveFormsAction implements Action {
	readonly type = ActionTypes.SET_ACTIVE_FORMS;

	constructor( public payload: ActiveForms ) { }
}

export class SetToCompactNavMenuAction implements Action {
	readonly type = ActionTypes.SET_COMPACT_NAV_MENU;

	constructor( public payload: boolean ) { }
}


export class SetMediaAction implements Action {
	readonly type = ActionTypes.SET_MEDIA;

	constructor(
		public payload: IMedia
	) { }
}


export class SetUiEventAction implements Action {
	readonly type = ActionTypes.SET_UI_EVENT;

	constructor( public payload: { eventName: string; data: any } ) { }
}


export class SetUiLanguage implements Action {
	readonly type = ActionTypes.SET_UI_LANGUAGE;

	constructor( public payload: string ) { }
}

export class ShowPageLoaderAndCountUp implements Action {
	readonly type = ActionTypes.SHOW_PAGE_LOADER_AND_COUNT_UP;

	constructor( public payload: IPageLoader ) { }
}

export class HidePageLoaderAndResetCounter implements Action {
	readonly type = ActionTypes.HIDE_PAGE_LOADER_AND_RESET_COUNTER;

	constructor( public payload: IPageLoader ) { }
}

export class HidePageLoaderOrCountDown implements Action {
	readonly type = ActionTypes.HIDE_PAGE_LOADER_OR_COUNT_DOWN;

	constructor( public payload: IPageLoader ) { }
}


export type Actions =
	SetActiveFormsAction
	| SetMediaAction
	| ShowPageLoaderAndCountUp
	| HidePageLoaderAndResetCounter
	| HidePageLoaderOrCountDown
	| SetToCompactNavMenuAction
	| SetUiEventAction
	| SetUiLanguage;
